"use strict";
var ACC;

function bindHeaderClickToTrigger(header, trigger) {
	if (header._legacyCollapseHeaderBound) return;

	header._legacyCollapseHeaderBound = true;
	header.addEventListener("click", (event) => {
		if (!(event.target instanceof Element)) return;
		if (
			trigger.contains(event.target) ||
			event.target.closest(
				"a, button, input, select, textarea, label, [contenteditable]"
			)
		) return;
		trigger.click();
	});
}

ACC.global = {

	_autoload: [
		"migrateLegacyBootstrapAttributes",
		"bindToggleXsSearch",
		"bindToggleHeaderLinks",
		"bindHoverIntentMainNavigation",
		"bindTouchstartNavigation",
		"initImager",
		"reprocessImages",
		"backToHome",
		"checkboxCheck",
		"bindEditorialComponent",
		"bindModalPopupEvent",
		"initEditorialComponent",
		"bindBackgroundContainerViewAdjustments",
		"initCustomDropdownTag",
		"alignTitleHeights"
	],
	// mapping facets name to cover case with different name
	labelMap: {
		'category': 'category',
		'collection': 'collection',
		'colour': 'colorGroup',
		'brand': 'brand',
		'price': 'price',
		'style': 'style',
		'size': 'size',
		'material': 'material',
		'percentSaving': 'percentSaving'
	},

	/* START: enable/disable scroll */
	scrollFixedTop: 0,
	scrollPosition: 0,
	disableScroll: function() {
		var $body = $(document.body);
		this.scrollFixedTop = ACC.cookie.getAreaOpenMessageHeight();
		this.scrollPosition = window.scrollY;
		$body.css({
			top: "-" + this.scrollPosition + "px",
			overflow: "hidden"
		});

		$(document).trigger("scrollingdisabled");
	},

	enableScroll: function() {
		$(document.body).css({
			"margin-top": '',
			top: '',
			overflow: ''
		});

		window.scrollTo(0, this.scrollPosition);
		$(document).trigger("scrollingenabled");
	},

	/* helper: function to disable scroll on <main></main> tag element - used for mobile sidepanel menu when opened to disable background scroll */
	disableScrollOnMain: function(disable) {
		var $main = $('main');
		if (disable) {
			$main.addClass('disable-scroll');
		} else {
			$main.removeClass('disable-scroll');
		}
	},
	/* END: enable/disable scroll */

	// Getter/Setter for referrer (used in page persistence).
	// @page (String) Name of page set as previous.
	referrer: function(page) {
		return arguments.length && page ?
			window.localStorage.setItem("referrer", page)
			: window.localStorage.getItem("referrer");
	},

	// Get the maximum height from a group of elements.
	// @$collection (jQuery collection) The group of elements to check.
	getMaxHeight: function($collection, includeMargin) {
		var max = 0;
		var margin = arguments.length > 1 ? includeMargin : false;
		$collection.each(function() {
			var height = $(this).outerHeight(margin);
			if(height > max) {
				max = height;
			}
		});
		return max;
	},

	// Set heights of pass items to be equal to maximum detected.
	// @$items (jQuery collection) Elements to match in height.
	alignHeights: function($items) {
		var max = ACC.global.getMaxHeight($items);
		ACC.global.setHeight(max, $items);
	},

	// Set the height of an elements to the passed value.
	// @height (String|Number) Height value.
	// @$items (jQuery collection) Elements that want to receive the height value.
	setHeight: function(height, $items) {
		$items.css("height", String(height + "px"));
	},

	alignTitleHeights: function() {
        const $titles = $('.reward-yourself__container_box h3');
        if($titles.length > 0) {
            ACC.global.alignHeights($titles);
        }
    },

	// Given an element with a width, figure out how many words
	// will fit before wrapping occurs. This is an attempt to
	// provide a non-word-breaking version of CSS text-overflow:ellipsis
	// @$container (jQuery element) Element directly containing the words.
	// @ellipsis (Boolean) Include ellipsis when content clipped.
	fitMaximumWords: function($container, ellipsis) {
		var suffix = arguments.length > 1 ? "..." : "";
		var display = $container.css("display");
		var width = $container.width();
		var text = $container.text();
		var words = text.split(" ");
		var content = "";
		var was;

		// First clear width.
		$container.css({
			display: "inline-block",
			width: "auto"
		});

		// Find out how many words can fit.
		for(var i=0; i<words.length; ++i) {
			was = content;
			content = words.slice(0, i+1).join(" ");
			$container.text(content + suffix);

			// Have we added too much?
			if($container.width() > width) {
				$container.text(was + (was !== text ? suffix : ""));
				break;
			}
		}

		// If we added everything we already had, remove any ellipsis.
		if($container.text() === text + suffix) {
			$container.text(text);
		}

		// Reset to original CSS.
		$container.css({
			display: display,
			width: width + "px"
		});
	},

	detectWindowResize: function (pageType) {
		// Global state variable.  detectWindowResize NOT auto-loaded.
		var responsizeXSmall = Modernizr.mq('(max-width: 640px)'),
			responsizeSmall = Modernizr.mq('(max-width: 768px)'),
			responsizeMedium = Modernizr.mq('(max-width: 979px)'),
			winSize = '';
		if (responsizeXSmall) {
			winSize = 'xs';
		} else if (responsizeSmall) {
			winSize = 'sm';
		} else if (responsizeMedium) {
			winSize = 'md';
		} else {
			winSize = 'lg';
		}

		if (pageType === 'storeDetails'){
			if(winSize === 'md' || winSize === 'lg'){
				ACC.storedetail.storeDetailsLgSize();
			} else {
				ACC.storedetail.storeDetailsSmSize();
			}
		}

		window.onresize = function () {
			var newWinSize = '';
			if (($(this).width() >= 641) && ($(this).width() <= 768)) {
				newWinSize = 'sm';
			} else if (($(this).width() >= 769) && ($(this).width() <= 979)) {
				newWinSize = 'md';
			} else if ($(this).width() >= 980) {
				newWinSize = 'lg';
			} else {
				newWinSize = 'xs';
			}
			if( newWinSize !== winSize ) {
				winSize = newWinSize;
				if (pageType === 'checkout') {
					if ($(this).width() > 768) {
						$('.scroll-pane').jScrollPane();
					}
				}

				if (pageType === 'editorialpage'){
					if($('.editorial-content').length){
						ACC.global.editorialComponentScrollAdjustment();
					}
				}

				if (pageType === 'storeDetails'){
					if(winSize === 'md' || winSize === 'lg'){
						ACC.storedetail.storeDetailsLgSize();
					} else {
						ACC.storedetail.storeDetailsSmSize();
					}
				}

			}
		};

	},

	bindToggleXsSearch: function(){
		$(document).on("click",".js-toggle-xs-search",function(){
			ACC.global.toggleClassState($(".site-search"),"active");
		});
	},

	bindToggleHeaderLinks: function(){
		$(document).on("click",".js-toggle-header-links",function(){
			var $e = $(".md-secondary-navigation");
			$(this).blur();
			ACC.global.toggleClassState($(this),"active");
			ACC.global.toggleClassState($e,"active")? $e.slideDown(300): $e.slideUp(300);
		});
	},

	toggleClassState: function($e,c){
		$e.hasClass(c)? $e.removeClass(c): $e.addClass(c);
		return $e.hasClass(c);
	},

	bindHoverIntentMainNavigation: function(){
		$("nav.main-navigation > ul > li:not(.tree-navigation)").hoverIntent({
			over: function(){
				ACC.global.showMegaMenu($(this));
			},
			out: function(){
				ACC.global.hideMegaMenu($(this));
			},
			timeout: 100,
			sensitivity: 4
		});
	},

	bindTouchstartNavigation: function(){
		var isTabletMinBP = Modernizr.mq('(min-width: 769px)'),
			isTouch = Modernizr.touchevents;

		if(isTabletMinBP && isTouch) {
			$("nav.main-navigation > ul > li:not(.tree-navigation)").on('touchstart', 'a', function(evt) {
				var $liElement = $(this).parent('li');
				if($liElement.hasClass('has-sub') && !$liElement.find('.sub-navigation').height()) {
					evt.preventDefault();
					$liElement.find('.nav-cancel').show();
					ACC.global.hideAllMegaMenu($liElement);
					ACC.global.showMegaMenu($liElement);
				}
			});

			$(document).on('touchstart',".nav-cancel",function(){
				var $elem = $(this).closest('li');
				setTimeout(function(){
					ACC.global.hideMegaMenu($elem);
				}, 300);
			});
		}
	},

	hideAllMegaMenu: function($element) {
		$element.siblings().each(function() {
			if($(this).hasClass('md-show-sub')) {
				ACC.global.hideMegaMenu($(this));
			}
		});

		$(document).bind("touchstart", function(event){
			var $megaMenu = $('li.md-show-sub');

			if(!event.target.className.includes('nav-cancel')) {
				if (!$megaMenu.is(event.target) && $megaMenu.has(event.target).length === 0) {
					ACC.global.hideMegaMenu($megaMenu);
				}
			}
		});
	},

	showMegaMenu: function($element) {
		var count, lineHeight;
		$element.addClass("md-show-sub");
		if ($element.hasClass('has-sub')){
			count = $element.index() + 1;
			lineHeight = $element.find('.row').height() - 26;
			$('.main-content .layer').addClass('bg-transparent');
			$('head').append('<style type="text/css"> .main-navigation li:nth-child('+count+') .sub-navigation-section:before{height:'+ lineHeight  +'px;}</style>');
			ACC.global.showHideBgTransparent($element, 'show');
		} else {
			$('.main-content .layer').removeClass('bg-transparent');
		}
	},

	hideMegaMenu: function($element) {
		$element.removeClass("md-show-sub");
		$('.main-content .layer').removeClass('bg-transparent');
	},

	showHideBgTransparent: function($element, display) {
		$element.find('.sub-navigation').one($.support.transition.end, function(e){
			if(display === 'hide') {
				var isThereAnotherSubMenu = $('.md-show-sub').length;
				if (isThereAnotherSubMenu === 0) {
					$('.main-content .layer').removeClass('bg-transparent');
				}
			}
			$(this).off(e);
		});
	},

	initImager: function (elems) {
		elems = elems || '.js-responsive-image';
		this.imgr = new Imager(elems);
	},

	reprocessImages: function (elems) {
		elems = elems || '.js-responsive-image';
		if (this.imgr == undefined) {
			this.initImager(elems);
		} else {
			this.imgr.checkImagesNeedReplacing($(elems));
		}
	},

	// Usage: ACC.global.addGoogleMapsApi("callback function");
	// @callback (Function) name like "ACC.global.myfunction"
	addGoogleMapsApi: function(callback){
		if(callback != undefined) {
			if($(".js-googleMapsApi").length === 0){
				$('head').append('<script class="js-googleMapsApi" onload="$(document).trigger()" type="text/javascript" src="//maps.googleapis.com/maps/api/js?key='+ACC.config.googleApiKey+'&loading=async&callback='+callback+'"></script>');
			}
			else {
				ACC.global.executeNamespacedFunction(callback);
			}
		}
	},

	// Usage: ACC.global.addYouTubeApi("callback.namespace.function");
	// @callback (Function) Optional function name
	//           Include namespace if parent not window object, e.g. "ACC.global.myfunction"
	// Note: Inserting with jQuery silences the onload event. We also need to add src after add to DOM + onload.
	addYouTubeApi: function(callback){
		var cb = arguments.length ? callback : "";
		var script;
		if($(".js-YouTubeApi").length === 0){
			script = document.createElement("script");
			script.setAttribute("className", "js-YouTubeApi");
			document.head.appendChild(script);
			script.setAttribute("onload", 'window.onYouTubeIframeAPIReady = function() { ACC.global.executeNamespacedFunction("' + cb + '"); }');
			script.setAttribute("src", "https://www.youtube.com/iframe_api");
		}
		else {
			ACC.global.executeNamespacedFunction(cb);
		}
	},

	// Takes a namespaced string and works out the resulting function to call.
	// E.g. "ACC.something.foo" will result in calling foo() on ACC.something object.
	executeNamespacedFunction: function(namespace) {
		var split = arguments.length ? namespace.split(".") : null;
		var obj = window;
		if(split){
			while(split.length > 1) {
				obj = obj[split.shift()];
			}

			obj[split.shift()]();
		}
	},

	// Allows text to be retrieved from the JSP by setting it as JSON on node attribute.
	// @obj (Object) = Where to store the key/value text.
	// @$node (jQuery object) = Where to find the attribute value containing JSON.
	// e.g. <div data-element-text="{'foo': 'some text', 'bar': 'some more'}"></div>
	setDataElementText: function(obj, $node) {
		// Because we want to use double-quotes for attribute markup, and single-quotes inside,
		// we need to perform a replace, because JSON.parse wants it the other way round *sigh!*.
		var text = $node.data("element-text") || "{}";
		var data = JSON.parse(text.replace(/'/g, "\""));
		for(var key in data) {
			obj[key] = data[key];
		}
	},

	backToHome: function(){
		$(".backToHome").on("click", function(){
			var sUrl = ACC.config.contextPath;
			window.location = sUrl;
		});
	},

    toggleCheckbox: function(el) {
        if (el.attr('checked') === 'checked') {
            el.data('checked',0);
            el.prop('indeterminate',false);
            el.prop('checked',false);
            el.removeAttr('checked');
            el.attr('value', false);
            el.closest('label').removeClass('checked');
            el.closest('label').removeClass('indeterminate');
        } else {
            el.data('checked',1);
            el.prop('indeterminate',false);
            el.prop('checked',true);
            el.attr('checked','checked');
            el.attr('value', true);
            el.closest('label').addClass('checked');
        }
    },

	checkboxCheck: function(){
		// Check box
		var $check = $("input[type=checkbox]"), initialPos;
		$.each($check, function(){
			var el = $(this);

			if(el.prop('checked') === true){
				el.closest('label').addClass('checked');
                el.attr('value', true);
			}
            /* This method is called on page load and
               after the CheckoutAddress Vue component is mounted
               (and anytime adding a new billing/delivery address fails).
               To prevent attaching more click events to the same element,
               we're first unbinding any existing previous event.
            */
            el.data('checked', initialPos).unbind('click');
		    el.data('checked', initialPos).click(function() {
		        ACC.global.toggleCheckbox(el);
			});
	   });
	},

	/*
	Something in page slowing down ability to get
	correct calculations for editorial component scroll
	adjustment, so adding to window.load in hope it will
	be enough delay to get correct calculations.
	**/
	initEditorialComponent: function() {
		$(window).on('load', ACC.global.editorialComponentScrollAdjustment);
	},

	bindEditorialComponent: function (){
		$(".editoralNav ul li").on("click", function() {
			var $link = $(this).find('a'),
				newWindow = $link.attr("target") === "_blank",
				url = $link.attr("href");

			if (url) {
				window.open(url, newWindow ? "_blank" : "_self");
				return false;
			}
		});

		$(window).on("orientationchange", function() {
			ACC.global.editorialComponentScrollAdjustment();
		});
	},

	// Scroll selected item into view if area wider than viewport (e.g. mobile)
	editorialComponentScrollAdjustment: function () {
		var $scrollWrap = $('.editorial-content .scroll-wrp');
		var $active = $scrollWrap.find("li.active");
		var documentWidth = $(document).width();
		var scrollWidth;
		if($active.length) {
			scrollWidth = $scrollWrap.get(0).scrollWidth;
			if(scrollWidth > documentWidth) {
				$scrollWrap.scrollLeft($active.position().left);
			}
		}
	},

	setPosition: function (type, divWidth, count, activeLi){
		var windowWidth = $(window).width();
		var activeClass = false;
		var liWidth = $('.editoralNav ul li').outerWidth(true);
		$('.editoralNav').css('min-width', divWidth + 'px');
		$('.editoralNav ul li').each(function () {
			if ($(this).hasClass('active') === true){
				activeClass = $(this).hasClass('active');
			}
		});

		if ((activeClass === true) && (activeLi > 2)){
			if (count > 2){
				if (divWidth > windowWidth){
					if (activeLi === 3 || type === 'mobile'){
						if (count > 3){
							var activeLiLeft = (activeLi - 1) * liWidth + (count * 2);
							var scrollPosition = (( (activeLiLeft + liWidth) - windowWidth) + activeLiLeft) / 2;
							$(".scroll-wrp").scrollLeft(scrollPosition);
						} else {

							if (type === 'true'){
								$('.editoralNav ul').css('text-align', 'left');
							}
						}
					}
				}
			}
		}
	},

	_legacyAccordionIdCounter: 0,

	// CMS content (impex-managed accordions/modals) still ships with the old Bootstrap 3/4
	// data-toggle/data-parent attributes, which Bootstrap 5 no longer reads. Rewrite them at
	// runtime instead of editing every impex file across every locale/release, and add a
	// chevron indicator + full-header click target since the CMS markup only wires the <a>.
	migrateLegacyBootstrapAttributes: function (root) {
		const scope = root?.nodeType === 1 ? root : document;

		// Some CMS content already ships its own expand/collapse icon - covers every icon
		// naming convention used across the site so we don't render a second chevron.
		const EXISTING_CHEVRON_SELECTOR = [
			"[data-accordion-arrow]", '[class*="chevron"]', '[class*="caret"]',
			'[class*="icon-down-open"]', '[class*="icon-up-open"]',
			'[class*="angle-down"]', '[class*="angle-up"]', '[class*="arrow-icon"]',
			'[class~="arrow"]'
		].join(", ");

		function hasExistingChevron(trigger, header) {
			// "arrow"/"collapsed" (see tjxsingleaccordioncomponent.jsp, cms-contact-us.impex) is a
			// CSS-only background-image chevron on the trigger itself, not a child element.
			return trigger.matches(EXISTING_CHEVRON_SELECTOR) ||
				trigger.querySelector(EXISTING_CHEVRON_SELECTOR) !== null ||
				(header !== trigger && (header.matches(EXISTING_CHEVRON_SELECTOR) || header.querySelector(EXISTING_CHEVRON_SELECTOR) !== null));
		}

		// SmartEdit-authored content doesn't always use the ".panel-group"/".accordion" class
		// convention, so fall back to finding the nearest ancestor that actually wraps more than
		// one collapse panel - this works no matter what class/id the content author used.
		function findAccordionGroupAncestor(panel) {
			let ancestor = panel.parentElement;
			while (ancestor && ancestor !== document.body) {
				if (ancestor.querySelectorAll(":scope .collapse").length > 1) {
					return ancestor;
				}
				ancestor = ancestor.parentElement;
			}
			return null;
		}

		// CMS content isn't schema-validated, so an invalid selector (e.g. unescaped
		// characters) must not throw and abort migration for the rest of the page.
		function resolveDeclaredAccordionParent(declaredParentSelector) {
			try {
				return declaredParentSelector ? document.querySelector(declaredParentSelector) : null;
			} catch (error) {
				console.warn(`Invalid data-bs-parent selector "${declaredParentSelector}"`, error);
				return null;
			}
		}

		function resolveAccordionParent(panel, trigger) {
			return resolveDeclaredAccordionParent(trigger.dataset.bsParent) ||
				// Guards against mistyped selectors (e.g. "#accordian") in CMS content.
				panel.closest(".panel-group, .accordion") ||
				// Last resort for SmartEdit content with no recognised wrapper class/id at all.
				findAccordionGroupAncestor(panel);
		}

		// Bootstrap 5's Collapse reads `data-bs-parent` off the panel itself (Bootstrap 3/4
		// put it on the trigger), so move/repair it here - only one accordion item stays open.
		function ensureBsParentAttribute(panel, trigger) {
			if (panel.dataset.bsParent) return;

			const parentElement = resolveAccordionParent(panel, trigger);
			if (!parentElement) return;

			if (!parentElement.id) {
				parentElement.id = `legacy-accordion-${++ACC.global._legacyAccordionIdCounter}`;
			}
			panel.dataset.bsParent = `#${parentElement.id}`;
		}

		function addAccordionChevron(trigger, panel) {
			const chevron = document.createElement("span");
			chevron.dataset.accordionArrow = "";
			chevron.setAttribute("aria-hidden", "true");

			Object.assign(trigger.style, {
				display: "flex", alignItems: "center", width: "100%",
				boxSizing: "border-box", gap: "12px"
			});

			Object.assign(chevron.style, {
				display: "inline-block", width: "8px", height: "8px",
				borderRight: "2px solid currentColor",
				borderBottom: "2px solid currentColor",
				marginInlineStart: "auto", marginInlineEnd: "4px",
				flexShrink: "0"
			});

			trigger.appendChild(chevron);

			function updateChevron(isOpen) {
				chevron.style.transform = isOpen ? "rotate(225deg)" : "rotate(45deg)";
			}

			updateChevron(panel.classList.contains("show"));

			panel.addEventListener("shown.bs.collapse", (event) => {
				if (event.target === panel) updateChevron(true);
			});
			panel.addEventListener("hidden.bs.collapse", (event) => {
				if (event.target === panel) updateChevron(false);
			});
		}

		function setupAccordions(scope) {
			const replacements = {
				"data-toggle": "data-bs-toggle",
				"data-parent": "data-bs-parent"
			};

			Object.entries(replacements).forEach(([oldAttribute, newAttribute]) => {
				scope.querySelectorAll(`[${oldAttribute}]`).forEach((element) => {
					element.setAttribute(newAttribute, element.getAttribute(oldAttribute));
					element.removeAttribute(oldAttribute);
				});
			});

			scope.querySelectorAll('a[data-bs-toggle="collapse"][href]').forEach((trigger) => {

				const panel = document.getElementById(trigger.hash.slice(1));
				const header = trigger.parentElement;

				if (!panel) return;

				ensureBsParentAttribute(panel, trigger);

				if (!header || hasExistingChevron(trigger, header)) return;

				addAccordionChevron(trigger, panel);
				bindHeaderClickToTrigger(header, trigger);
			});
		}

		const run = () => setupAccordions(scope);

		if (scope === document && document.readyState === "loading") {
			document.addEventListener("DOMContentLoaded", run, { once: true });
		} else {
			run();
		}

		// Watch for CMS content added later (e.g. ajax-loaded modal content) and migrate that too.
		if (scope === document && window.MutationObserver && !ACC.global._legacyBootstrapAttributeObserverBound) {
			ACC.global._legacyBootstrapAttributeObserverBound = true;
			new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (node.nodeType === 1) {
							ACC.global.migrateLegacyBootstrapAttributes(node);
						}
					});
				});
			}).observe(document.body, { childList: true, subtree: true });
		}
	},

	bindModalPopupEvent: function () {
		$("#extLinkPopup").on('hidden.bs.modal', function () {
			const modalContent = $(this).find('.modal-content');
			modalContent.html('')
			$(this).data('bs.modal', null);
			$(modalContent).scrollTop( 0 );
		});

		$('body').on('hidden.bs.modal', '.modal', function () {
			const modalContent = $(this).find('.modal-content');
			modalContent.html('')
			$(this).removeData('bs.modal');
			$(modalContent).scrollTop( 0 );
		});

		$('#extLinkPopup').on('hidden', function(){
			$(this).data('bs.modal', null);
		});

		// Bootstrap 5 sets aria-hidden on the modal once it finishes hiding; blur any focused
		// descendant (e.g. the close button) up front so focus isn't left behind an aria-hidden ancestor.
		// Bootstrap also focuses the modal element itself (tabindex="-1") when shown, so check for that too.
		$('body').on('hide.bs.modal', '.modal', function () {
			if (document.activeElement && (this === document.activeElement || $.contains(this, document.activeElement))) {
				document.activeElement.blur();
			}
		});
   
		// Bootstrap 5 dropped the old data-api "remote" href auto-load behaviour, so fetch it ourselves
		$('#extLinkPopup').on('show.bs.modal', function (event) {
			const href = $(event.relatedTarget).attr('href');
			const modalContent = $(this).find('.modal-content');

			if (href && href.indexOf('#') !== 0) {
				modalContent.load(href);
			}
		});

		$('#extLinkPopup').on("shown.bs.modal", function () {
			var obj = $(this).find('.modal-content');
			$(obj).scrollTop( 0 );
		});
	},

	// Smooth scrolls to required element, if found.
	// @where (String) jQuery selector
	// @offset (Number) prevent scrolling too high by altering the position number.
	scrollToElement: function(selector, offset) {
		var $target = $(selector);
		var adjustment = offset ? offset : 0;
		if($target.length) {
			$('html, body').animate({
				scrollTop: $target.offset().top - adjustment
			}, 500);
		}
	},

	/* CMS controls background images but we pump this out through <picture>
	 * elements to give resonsive control. This function takes the loaded
	 * image and updates the parent containers style.backgroundImage setting.
	 * Note: picturfill gives us the use of cross-browser img.currentSrc.
	 * If any problems in seeing the correct image, investigate that area first.
	 */
	bindBackgroundContainerViewAdjustments: function() {
		$('.background-container').each(function (i) {
			var $container = $(this);
			var $image = $container.find("img");
			//$container.css("background-image", "url(" + this.currentSrc + ")");
			$image.css("visibility", "hidden"); // Hide and expose container background.
			$image.on("load", function(e) {
				$container.css("background-image", "url(" + this.currentSrc + ")");
			});
		});
	},

	/* Custom Dropdown Functionality for whole site
	 */
	initCustomDropdownTag: function() {
		$('.custom-dropdown').each(function() {
			var $customDropdown = $(this),
				$dropdownOptions = $customDropdown.find('.dropdown-menu'),
				$button = $customDropdown.find('button.dropdown-toggle'),
				changeValue = function ($optionElem) {
					var optionValue = $optionElem.data('value'),
						optionText = $optionElem.text();

					if ($optionElem.hasClass('disabled')) {
						return;
					}
					//update button text
					$button.text(optionText);
					$button.data('value', optionValue);
				};

			$dropdownOptions.on('click', 'li', function() {
				changeValue($(this));
			});

			ACC.global.animateDropdown();
		});
	},

	/* animate slide down and slide up dropdown
	 */
	animateDropdown: function() {

		// Bootstrap 5 dispatches these as native events with the literal type
		// "show.bs.dropdown"/"hide.bs.dropdown", so jQuery's namespaced .on()
		// binding never matches it - use addEventListener instead.
		$('.dropdown').each(function() {
			this.addEventListener('show.bs.dropdown', function() {
				$(this).find('.dropdown-menu').first().stop(true, true).slideDown();
			});
			this.addEventListener('hide.bs.dropdown', function() {
				$(this).find('.dropdown-menu').first().stop(true, true).slideUp();
			});
		});
	},


    /**
     * @description used on Smart Edit - reload the TJX Loyalty VueJS components
     * VueJS components fixed:
     * card-template, card-maintenance-template, add-card-to-wallet-template
     * @todo fix for refer-friend-template
     */
	smartEditRefreshTJXLoyaltyComponents: function() {
        var inlineComponents = Array.from($('.js-tjx-loyalty[inline-template]'));

        inlineComponents.forEach(function(comp) {
            comp.removeAttribute('data-v-cloak');
            window.reloadVueComponent(comp.parentElement);
        });
    }
};
